import { render, staticRenderFns } from "./pendingReview.vue?vue&type=template&id=f30207b0&"
import script from "./pendingReview.vue?vue&type=script&lang=js&"
export * from "./pendingReview.vue?vue&type=script&lang=js&"
import style0 from "./pendingReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports